// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"Footer_footerWrapper__1hh8D","footer":"Footer_footer__1Bpa3","title":"Footer_title__1s1JE","bottomFooter":"Footer_bottomFooter__3KBJ1"};